<template>
  <div class="tabsContent1">
    <div class="power-data">
      能耗指标数据
    </div>
    <div class="data-card">
      <div class="card-item">
        <div class="card-left">
          <div>
            今日用电(kwh)
          </div>
          <div class="blue-font">
            {{ powerdata.todayEnergy }}
            <span class="red-font" v-if="Number(powerdata.yesterdaySamePeriodRingRatio) > 0"><img class="jiantou" src="../../../assets/station/up.png" alt=""> {{ powerdata.yesterdaySamePeriodRingRatio}} %</span>
            <span class="green-font" v-else ><img class="jiantou" src="../../../assets/station/down.png" alt="">   {{ powerdata.yesterdaySamePeriodRingRatio}} %</span>
          </div>
        </div>
        <div class="card-left">
          <div>
            昨日用电(kwh)
          </div>

          <div class="gray-font">
            {{ powerdata.yesterdaySamePeriodEnergy }}
          </div>
        </div>
      </div>
      <div class="card-item">
        <div class="card-left">
          <div>
            本周用电(kwh)
          </div>
          <div class="blue-font">
            {{ powerdata.thisWeekEnergy }}
            <span class="red-font" v-if="Number(powerdata.oneBeforeWeekSamePeriodRingRatio) > 0"><img class="jiantou" src="../../../assets/station/up.png" alt=""> {{ powerdata.oneBeforeWeekSamePeriodRingRatio}} %</span>
            <span class="green-font" v-else ><img class="jiantou" src="../../../assets/station/down.png" alt="">   {{ powerdata.oneBeforeWeekSamePeriodRingRatio}} %</span>
          </div>
        </div>
        <div class="card-left">
          <div>
            上周用电(kwh)
          </div>
          <div class="gray-font">
            {{ powerdata.oneBeforeWeekSamePeriodEnergy }}
          </div>
        </div>
      </div>
      <div class="card-item">
        <div class="card-left">
          <div>
            本月用电(kwh)
          </div>
          <div class="blue-font">
            {{ powerdata.thisMonthEnergy }}
            <span class="red-font" v-if="Number(powerdata.oneBeforeMonthSamePeriodRingRatio) > 0"><img class="jiantou" src="../../../assets/station/up.png" alt=""> {{ powerdata.oneBeforeMonthSamePeriodRingRatio}} %</span>
            <span class="green-font" v-else ><img class="jiantou" src="../../../assets/station/down.png" alt="">   {{ powerdata.oneBeforeMonthSamePeriodRingRatio}} %</span>
          </div>
        </div>
        <div class="card-left">
          <div>
            上月用电(kwh)
          </div>
          <div class="gray-font">
            {{ powerdata.oneBeforeMonthSamePeriodEnergy }}
          </div>
        </div>
      </div>
    </div>
    <div class="power-data">
      能源趋势统计
    </div>
    <div class="item-group" style="margin-top: 24px;">
            <span class="item-btn " :class="isrisk=='day'?'active-btn':''" @click="changerisk('day')">
              日
              <div class="blue-blank">

              </div>
            </span>
      <span class="item-btn " :class="isrisk=='month'?'active-btn':''" @click="changerisk('month')">
              月
              <div class="blue-blank">

              </div>
            </span>
      <span class="item-btn " :class="isrisk=='year'?'active-btn':''" @click="changerisk('year')">
              年
              <div class="blue-blank">

              </div>
            </span>
      <div class="gray-line">

      </div>
    </div>
    <div class="time-select">
      <el-date-picker
        v-if="isrisk=='year'"
        v-model="year"

        size="large"
        type="year"
      >
      </el-date-picker>
      <el-date-picker
        v-model="month"
        v-if="isrisk=='month'"
        size="large"
        value-format="yyyy-MM"
        type="month"
      >
      </el-date-picker>
      <el-date-picker
        v-model="time"
        size="large"
        v-if="isrisk=='day'"
        value-format="yyyy-MM-dd"
        type="date"
     >
      </el-date-picker>
      <div class="btn-item" @click="searchdata()">
        查询
      </div>
    </div>
    <div class="cav-chart" id="trendCav">

    </div>

  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Vue from "vue";
import qs from "qs";

export default {
  name: "tabsContent1",
  data() {
    return {
      powerdata:{
        oneBeforeMonthSamePeriodEnergy:null,
        oneBeforeMonthSamePeriodRingRatio:null,
        oneBeforeWeekSamePeriodEnergy: null,
        oneBeforeWeekSamePeriodRingRatio: null,
        thisMonthEnergy: null,
        thisWeekEnergy: null,
        todayDeptTotalEnergy:null,
        todayEnergy: null,
        todayEnergyDeptProportion: null,
        yesterdaySamePeriodEnergy:null,
        yesterdaySamePeriodRingRatio: null,
      },
      isrisk:"day",
      time:"",
      month:"",
      year:"2023",
    };
  },
  mounted() {

    this.saveid=sessionStorage.getItem('saveid');
this.getpowerdata()
this.getnowtime()
this.searchdata()

  },
  methods: {
    searchdata(){
      let that = this;
      let param = {};
      let date=""
      let type=""
      if(this.isrisk=='day'){
        date=this.time
        param.url="/energy/monitorHourEnergyTrend";
        param.data={
          localDate:date,
          monitorSiteId:this.saveid
        }
      }else if(this.isrisk=='month'){
        date=this.month
        param.url="/energy/monitorDayEnergyTrend";
        param.data={
          yearMonth:date,
          monitorSiteId:this.saveid
        }
      }else if(this.isrisk=='year'){
        date=this.year
        param.url="/energy/monitorMonthEnergyTrend";
        param.data={
          year:date,
          monitorSiteId:this.saveid
        }
      }
      param.method="post";


      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.getchart2(res.data)
        }

      })
    },
    getchart2(data){

      let xdata=[]
      let ydata=[]
      let ydata2=[]
      let productCount=[]
      let productYield=[]
      for(let i=0;i<data.length;i++){
        xdata.push(data[i].dataTime)
        ydata.push(data[i].energy)
        ydata2.push(data[i].lastPeriodEnergy)
        // productCount.push(data[i].productCount)
        // productYield.push(data[i].productYield)
      }
      let myChart =this.$echarts.init(document.getElementById('trendCav'));
      let option = {
        tooltip: {
          trigger: 'axis',

        },
        grid: {
          right: '6%',

          left: '6%',
          top: '40px',
          containLabel: true
        },

        xAxis: [

          {
            type: 'category',
            data:xdata,

            axisLine: {
              lineStyle: {
                color: '#0B4CA9'
              }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#000",
                fontSize: 12,
              },
              // interval:0,
              //rotate:30
            },
          }],
        yAxis: [{
          type: 'value',

          nameTextStyle: {
            color: '#000'
          },
          position: 'left',
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show:false,
            lineStyle: {
              color: "#0B4CA9",
            }

          },
          axisLabel: {
            color: '#000',
            fontSize: 12,
          }
        },
          //   {
          //   type: 'value',
          //
          //   nameTextStyle: {
          //     color: '#000'
          //   },
          //   position: 'right',
          //   axisLine: {
          //     lineStyle: {
          //       color: '#0B4CA9'
          //     }
          //   },
          //   splitLine: {
          //     show:false,
          //     lineStyle: {
          //       color: "#0B4CA9",
          //     }
          //
          //   },
          //   axisLabel: {
          //     color: '#000',
          //     fontSize: 12,
          //   }
          // },
        ],
        series: [
          {
            name: "能耗",
            type: "line",

            smooth: true, //平滑曲线显示
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 4, //标记的大小
            itemStyle: {
              //折线拐点标志的样式
              color: "rgba(42,98,255, 1)"
            },
            lineStyle: {
              color: "rgba(42,98,255, 1)",
              width:3,
            },

            data:ydata
          },
          {
            name: "同期能耗",
            type: "line",

            smooth: true, //平滑曲线显示
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 4, //标记的大小
            itemStyle: {
              //折线拐点标志的样式
              color: "rgba(47, 194, 91, 1)"
            },
            lineStyle: {
              color: "rgba(47, 194, 91, 1)"
            },

            data:ydata2
          },
          // {
          //   name: "产量",
          //   type: "line",
          //   yAxisIndex:1,
          //   smooth: true, //平滑曲线显示
          //   showAllSymbol: true, //显示所有图形。
          //   symbol: "circle", //标记的图形为实心圆
          //   symbolSize: 4, //标记的大小
          //   itemStyle: {
          //     //折线拐点标志的样式
          //     color: "rgba(250, 204, 20, 1)"
          //   },
          //   lineStyle: {
          //     color: "rgba(250, 204, 20, 1)"
          //   },
          //
          //   data:productCount
          // },

        ]
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date ;


      this.month=year + "-" + month
      this.hour=time
      this.time = time;
      this.year=year

    },
    changerisk(data){

      this.isrisk=data
      if(data=='year'){
        let now = new Date();
        this.year= "2023"
      }
      this.searchdata()
    },
    getpowerdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/energy/monitorEnergyTotal";
      param.data={
        monitorSiteId:this.saveid,

      }
      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.powerdata=res.data
          for(let key in this.powerdata){
            if(Number(this.powerdata[key]) > 10000){
              this.powerdata[key]=(this.powerdata[key] / 10000).toFixed(2) +'万'
            }
          }
        }

      })
    },
  },
  watch: {

  },
  components: {}
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.time-select{
  float:right;
  margin-right:40px;
}
.cav-chart{
  margin-top: 60px;
  width:1600px;
  height:400px;
}
.btn-item{

  display: inline-block;
  width: 80px;
  height: 40px;
  background: #2A62FF;
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-left: 48px;
  cursor: pointer;

}
.jiantou{
  position: relative;
  top: 10px;
}
.power-data{
  margin-top: 40px;
  color: #252B3C;
  font-size: 14px;

}
.data-card{
  margin-top: 24px;
  position: relative;
  .btn-item{
    position: absolute;
    right: 40px;
    top: 20px;
    display: inline-block;
    width: 120px;
    height: 40px;
    background: #2A62FF;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    margin-left: 48px;
    cursor: pointer;

  }
}
.card-item{
  width: 400px;
  display: inline-block;
  position: relative;
  vertical-align: top;
  height: 122px;
  background: #F5F8FD;
  color: #7D879F;
  font-size: 14px;
  margin-right: 20px;
  .card-left{
    width: 50%;
    display: inline-block;
    vertical-align: top;
    padding: 33px 0 0 30px;
    .blue-font{
      margin-top: 14px;
      color: #2A62FF;
      font-size: 20px;
    }
    .red-font{

      font-size: 12px;
      color: #D61E1E;
      margin-left: 8px;
    }
    .green-font{

      font-size: 12px;
      color: #008B61;
      margin-left: 8px;
    }
    .gray-font{
      margin-top: 14px;
      font-size: 20px;
    }
  }
  .infor-point{
    position: absolute;
    top: 32px;
    right: 20px;
    cursor: pointer;
  }
}
.warm-blank{
  width: 1400px;
  margin: 0 auto;
  height: 300px;
}
.item-group{
  display:inline-block;
  cursor: pointer;
  .item-btn{
    font-size: 14px;
    color: #7D879F;
    margin-right: 36px;
    display: inline-block;
    z-index: 100;
    vertical-align: top;
    .blue-blank{
      width: 100%;
      margin-top: 12px;
      height: 2px;

    }

  }
  .item-btn:nth-last-child(2){
    margin-right: 10px;
  }
  .active-btn{
    color: #2A62FF;
    position: relative;
    .blue-blank{
      width: 100%;
      margin-top: 12px;
      height: 2px;
      background-color:  #2A62FF;

    }
  }
  .gray-line{
    height: 2px;
    border: 1px solid #F1F0F0;
    position: relative;
    top: -2px;
    z-index: 1;
  }
}
</style>

